import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TimeFrameInputDto, TimeFrameTypeDto } from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class TimeFrameRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  getTimeFrameWithoutPatient(patientId: string, visitId: string, timeFrameTypeDto: TimeFrameInputDto): Observable<TimeFrameTypeDto> {
    const fndHxEndpointUrl = `patients/${patientId}/visit/${visitId}/fnd/timeframe/nonpatient`;
    const hxEndpointUrl = `patients/${patientId}/timeframe/patient`;
    const endpointUrl = visitId ? fndHxEndpointUrl : hxEndpointUrl;
    return this.httpClientService.sendPostRequest(endpointUrl, timeFrameTypeDto);
  }

  getTimeFrameWithPatient(patientId: string, visitId: string, timeFrameTypeDto: TimeFrameInputDto): Observable<TimeFrameTypeDto> {
    const fndHxEndpointUrl = `patients/${patientId}/visit/${visitId}/fnd/timeframe/patient`;
    const hxEndpointUrl = `patients/${patientId}/timeframe/patient`;
    const endpointUrl = visitId ? fndHxEndpointUrl : hxEndpointUrl;
    return this.httpClientService.sendPostRequest(endpointUrl, timeFrameTypeDto);
  }
}
